import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutsideClickForTwoRef } from "../../../Hooks/useOutsideClickForTwoRef";
import DotsVertical from '../../../Assets/OrderManagement/DotsVertical.svg';
import { closeSizeChartKebabMenu, openSizeChartKebabMenu } from "../../../Features/inventoryManagementSlice";
import KebabMenu from "./KebabMenu";

function ChartListItem({ sizeChart, isLast }) {
    const dispatch = useDispatch();

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);
    
    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        dispatch(closeSizeChartKebabMenu());
    });

    const { sizeChartId } = useSelector((state) => state.inventoryManagement.sizeChartKebab);

    const handleOpenKebab = () => {
        if(sizeChartId === sizeChart.id) {
            dispatch(closeSizeChartKebabMenu());
        }
        else {
            dispatch(openSizeChartKebabMenu(sizeChart.id));
        }
    }

    return (
        <div className={`w-full text-base font-semibold text-[#121212] flex items-center py-2 ${isLast ? '' : 'border-b border-[#EAEAEA]'}`}>
            <div className="w-[70%] px-[10px] py-2 line-clamp-1">
                <p>{sizeChart.chartName} &#40;{sizeChart.chartType === 'Trousers, Phants, Jeans' ? 'Trousers, Pants, Jeans' : sizeChart.chartType}&#41;</p>
            </div>

            <div className="w-[calc(30%-44px)] px-[10px] py-2 line-clamp-1">
                {
                    sizeChart.chartType === 'Shoe & Sandals' || sizeChart.chartType === 'High Heels' ? 
                    <p>
                        {sizeChart?.sizes
                            .map(sizeObj => `${sizeObj.UK.sizeName}-${sizeObj.UK.cm}`)
                            .join(", ")}
                    </p> : 
                    <p>{sizeChart?.sizes.map(item => item.sizeName).join(', ')}</p>
                }
            </div>

            <div onClick={handleOpenKebab} ref={kebabButtonRef} className="size-11 flex cursor-pointer items-center justify-center">
                <div className='relative flex items-center justify-center outline-none'>
                    <img src={DotsVertical} alt="" />

                    {
                        sizeChartId === sizeChart.id && 
                        <KebabMenu 
                            boxRef={kebabRef} 
                            sizeChart={sizeChart} 
                        />
                    }
                </div>
            </div>
        </div>
    )
}

export default ChartListItem;
